export default (createStore) =>
  ({
    ledgerId,
    workflowId,
    accountEntryId = 'new',
    accountId,
    reconciliationTextId,
    showLedgerSource,
    accept = '',
    autoreconciliationFields = {},
  } = {}) => {
    const endpointParams = {
      ledgerId: ledgerId ? parseInt(ledgerId) : undefined,
      workflowId: workflowId ? parseInt(workflowId) : undefined,
      accountEntryId: accountEntryId,
      accountId: accountId ? parseInt(accountId) : undefined,
      reconciliationTextId: reconciliationTextId
        ? parseInt(reconciliationTextId)
        : undefined,
    }

    return createStore(
      endpointParams,
      showLedgerSource ? JSON.parse(showLedgerSource) : false,
      accept,
      typeof autoreconciliationFields === 'string'
        ? JSON.parse(autoreconciliationFields)
        : autoreconciliationFields
    )
  }
